import React from "react";
import { AuthContext } from "../context/authProvider";

/**
 * Permite acceder al contexto de autenticación.
 *
 * Lanza un error cuando se utiliza fuera de AuthProvider,
 * evitando trabajar con un contexto indefinido.
 */
const useAuthContext = () => {
  const context = React.useContext(AuthContext);

  if (context === undefined) {
    throw new Error(
      "useAuthContext debe utilizarse dentro de AuthProvider."
    );
  }

  return context;
};

export default useAuthContext;